import React, { useState } from 'react';

const PostCreator = () => {
 const [title, setTitle] = useState('');
 const [content, setContent] = useState('');
 const [imageFile, setImageFile] = useState(null);
 const [videoFile, setVideoFile] = useState(null);

 const createPost = async () => {
  try {
   // 1. Create post
   const postResponse = await fetch('YOUR_WORDPRESS_REST_API_ENDPOINT/posts', {
    method: 'POST',
    headers: {
     'Content-Type': 'application/json',
    },
    body: JSON.stringify({
     title: title,
     content: content,
     status: 'publish',
    }),
   });

   const postResult = await postResponse.json();
   const postId = postResult.id;

   // 2. Upload image (if imageFile is provided)
   if (imageFile) {
    const formDataImage = new FormData();
    formDataImage.append('file', imageFile);

    const imageResponse = await fetch(`YOUR_WORDPRESS_REST_API_ENDPOINT/media`, {
     method: 'POST',
     body: formDataImage,
    });

    const imageResult = await imageResponse.json();
    const imageId = imageResult.id;

    await fetch(`YOUR_WORDPRESS_REST_API_ENDPOINT/posts/${postId}`, {
     method: 'POST',
     headers: {
      'Content-Type': 'application/json',
     },
     body: JSON.stringify({
      featured_media: imageId,
     }),
    });
   }

   // 3. Upload video (if videoFile is provided)
   if (videoFile) {
    const formDataVideo = new FormData();
    formDataVideo.append('file', videoFile);

    const videoResponse = await fetch(`YOUR_WORDPRESS_REST_API_ENDPOINT/media`, {
     method: 'POST',
     body: formDataVideo,
    });

    const videoResult = await videoResponse.json();
    const videoId = videoResult.id;

    await fetch(`YOUR_WORDPRESS_REST_API_ENDPOINT/posts/${postId}`, {
     method: 'POST',
     headers: {
      'Content-Type': 'application/json',
     },
     body: JSON.stringify({
      content: `<p>${content}</p><video controls><source src="${videoResult.source_url}" type="${videoResult.mime_type}"></video>`,
     }),
    });
   }

   alert('Post created successfully!');
  } catch (error) {
   console.error('Error creating post:', error);
  }
 };

 return (
  <div>
   <h2>Create WordPress Post</h2>
   <div>
    <label>Title:</label>
    <input type="text" value={title} onChange={(e) => setTitle(e.target.value)} />
   </div>
   <div>
    <label>Content:</label>
    <textarea value={content} onChange={(e) => setContent(e.target.value)} />
   </div>
   <div>
    <label>Image File:</label>
    <input type="file" accept="image/*" onChange={(e) => setImageFile(e.target.files[0])} />
   </div>
   <div>
    <label>Video File:</label>
    <input type="file" accept="video/*" onChange={(e) => setVideoFile(e.target.files[0])} />
   </div>
   <button onClick={createPost}>Create Post</button>
  </div>
 );
};

export default PostCreator;
